export default "__VITE_ASSET__DvWoAsaR__"